import { useCallback, useRef, useState } from 'react';

import { UC_AVAILABLE_ACTIONS_URL_PATH } from '../../constants';
import type { CrossAppMenuItem } from '../../types';

import { transformItems } from './utils';

function getHomeUrl() {
	return new URL(window.location.href).origin;
}

export function useUniversalCreateApi() {
	const [items, setItems] = useState<CrossAppMenuItem[]>([]);
	const fetched = useRef(false);

	const fetchData: () => void = useCallback(() => {
		const url = `${getHomeUrl()}${UC_AVAILABLE_ACTIONS_URL_PATH}`;
		if (!fetched.current) {
			fetch(url, { credentials: 'include' })
				.then(async (res) => {
					const response = await res.json();
					if (response?.items) {
						const transformedItems = await transformItems(response.items);
						setItems(transformedItems);
						fetched.current = true;
					}
					return;
				})
				.catch((error) => {
					throw error;
				});
		}
		return;
	}, []);

	return { items, fetchData };
}
